// city-sector-manager.js - Farm to Home Location Manager - FIXED (Event Delegation)

class CitySectorManager {
  constructor() {
    this.config = null;
    this.selectedCity = null;
    this.selectedSector = null;
    this.selectedZone = null;
    this.modal = null;
    this.init();
  }
  
  async init() {
    console.log('🌾 Initializing Location Manager...');
    
    await this.loadConfiguration();
    
    const savedSelection = this.getSavedSelection();
    
    // 1. Load saved data
    if (savedSelection && this.isValidSelection(savedSelection)) {
      this.selectedCity = savedSelection.cityId;
      this.selectedSector = savedSelection.sectorId;
      this.selectedZone = savedSelection.zoneId;
      console.log('✓ Restored saved location:', savedSelection);
    }
    
    // 2. Setup the header button immediately
    this.showLocationBar();

    const isHomepage = window.location.pathname === '/' || window.location.pathname === '/pages/home';
    
    // 3. Force modal on homepage if no location selected
    if (isHomepage && (!this.selectedCity || !this.selectedSector)) {
      this.showModal();
    }
  }

  isHomepage() {
    return window.location.pathname === '/' || window.location.pathname === '/pages/home';
  }
  
  async loadConfiguration() {
    try {
      const configUrl = window.fthConfigUrl || 'https://raw.githubusercontent.com/ProgrammingHero1/farm-to-home-config/main/config.json'; 
      const response = await fetch(configUrl);
      if (!response.ok) throw new Error('Config not found');
      
      this.config = await response.json();
      console.log('✓ Configuration loaded:', this.config.cities.length, 'cities');
    } catch (error) {
      console.error('❌ Failed to load configuration:', error);
    }
  }
  
  showModal() {
    // 1. Create HTML if missing
    if (!document.getElementById('citySectorModal')) {
      this.createModalHTML();
    }
    
    this.modal = document.getElementById('citySectorModal');
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // 2. Populate Cities
    this.populateCityDropdown();
    
    // 3. Attach Listeners (ROBUST METHOD)
    this.attachEventListeners();
    
    // 4. Pre-fill existing selection if any
    if (this.selectedCity) {
      const citySelect = document.getElementById('citySelect');
      if (citySelect) {
        citySelect.value = this.selectedCity;
        
        // Force sector population immediately
        this.populateSectorDropdown(this.selectedCity);
        
        // Pre-select sector if it exists
        if (this.selectedSector) {
           setTimeout(() => {
             const sectorSelect = document.getElementById('sectorSelect');
             if (sectorSelect) {
                sectorSelect.value = this.selectedSector;
                this.checkConfirmButton();
             }
           }, 50);
        }
      }
    }
    
    console.log('📍 Location modal displayed');
  }
  
  hideModal() {
    if (this.modal) {
      this.modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  
  createModalHTML() {
    const modalHTML = `
      <div id="citySectorModal" class="city-sector-modal">
        <div class="city-sector-modal-content">
          <div class="modal-header">
            <div class="welcome-logo"></div>
          </div>
          
          <div class="modal-body">
            <form id="locationForm" class="location-form">
              
              <div class="form-group">
                <label for="citySelect" class="form-label">Select Your City</label>
                <div class="select-wrapper">
                  <select id="citySelect" class="form-select" required>
                    <option value="">-- Choose Your City --</option>
                  </select>
                  <span class="select-arrow">▼</span>
                </div>
              </div>
              
              <div class="form-group" id="sectorGroup" style="display: none;">
                <label for="sectorSelect" class="form-label">Select Your Sector</label>
                <div class="select-wrapper">
                  <select id="sectorSelect" class="form-select" required disabled>
                    <option value="">-- First Select a City --</option>
                  </select>
                  <span class="select-arrow">▼</span>
                </div>
              </div>
              
              <button type="submit" id="confirmLocationBtn" class="btn-primary" disabled>
                <span class="btn-icon">✓</span>
                Confirm & Start Shopping
              </button>
              
            </form>
          </div>
          
          <div class="modal-footer">
            <p class="footer-note">🔒 Your location helps us show you the freshest products from nearby farms</p>
          </div>
          
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }
  
  attachEventListeners() {
    const modal = document.getElementById('citySectorModal');
    if (!modal) return;

    // Prevent attaching duplicate listeners
    if (modal.getAttribute('data-listeners-attached') === 'true') return;

    console.log('🔗 Attaching ROBUST event listeners...');

    // EVENT DELEGATION: Listen to ALL changes inside the modal
    modal.addEventListener('change', (e) => {
      // 1. Handle City Change
      if (e.target && e.target.id === 'citySelect') {
        const cityId = e.target.value;
        console.log('🏙️ City Changed to:', cityId);
        
        if (cityId) {
          this.populateSectorDropdown(cityId);
        } else {
          // Hide sector if city is cleared
          const sectorGroup = document.getElementById('sectorGroup');
          if (sectorGroup) sectorGroup.style.display = 'none';
        }
        this.checkConfirmButton();
      }

      // 2. Handle Sector Change
      if (e.target && e.target.id === 'sectorSelect') {
        console.log('🏘️ Sector Changed to:', e.target.value);
        this.checkConfirmButton();
      }
    });

    // Handle Form Submit
    const form = document.getElementById('locationForm');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.confirmSelection();
      });
    }

    // Mark as attached
    modal.setAttribute('data-listeners-attached', 'true');
  }
  
  populateCityDropdown() {
    const citySelect = document.getElementById('citySelect');
    if (!citySelect || !this.config) return;
    
    // Keep existing selection if possible, otherwise reset
    const currentVal = citySelect.value;
    citySelect.innerHTML = '<option value="">-- Choose Your City --</option>';
    
    this.config.cities.forEach(city => {
      const option = document.createElement('option');
      option.value = city.id;
      option.textContent = city.name;
      citySelect.appendChild(option);
    });

    if (currentVal) citySelect.value = currentVal;
  }
  
  populateSectorDropdown(cityId) {
    const sectorSelect = document.getElementById('sectorSelect');
    const sectorGroup = document.getElementById('sectorGroup');
    
    if (!sectorSelect || !sectorGroup) {
      console.error('❌ Sector elements missing in DOM');
      return;
    }
    
    const city = this.config.cities.find(c => c.id === cityId);
    if (!city) return;
    
    console.log(`📋 Populating sectors for ${city.name}...`);

    // Reset sectors
    sectorSelect.innerHTML = '<option value="">-- Choose Your Sector --</option>';
    
    city.sectors.forEach(sector => {
      const option = document.createElement('option');
      option.value = sector.id;
      option.textContent = sector.name;
      option.dataset.zone = sector.zone;
      sectorSelect.appendChild(option);
    });
    
    // CRITICAL: Force display block
    sectorGroup.style.display = 'block';
    sectorSelect.disabled = false;
    
    console.log('✅ Sector group set to visible');
  }
  
  checkConfirmButton() {
    const cityId = document.getElementById('citySelect')?.value;
    const sectorId = document.getElementById('sectorSelect')?.value;
    const confirmBtn = document.getElementById('confirmLocationBtn');
    
    if (confirmBtn) {
      if (cityId && sectorId) {
        confirmBtn.disabled = false;
        confirmBtn.style.opacity = '1';
        confirmBtn.style.cursor = 'pointer';
      } else {
        confirmBtn.disabled = true;
        confirmBtn.style.opacity = '0.5';
        confirmBtn.style.cursor = 'not-allowed';
      }
    }
  }

  confirmSelection() {
    const citySelect = document.getElementById('citySelect');
    const sectorSelect = document.getElementById('sectorSelect');
    
    const cityId = citySelect.value;
    const sectorId = sectorSelect.value;
    
    if (!cityId || !sectorId) {
      alert('Please select both city and sector');
      return;
    }
    
    const city = this.config.cities.find(c => c.id === cityId);
    const sector = city.sectors.find(s => s.id === sectorId);
    const zoneId = sector.zone;
    
    const savedSelection = this.getSavedSelection();
    const isLocationChange = savedSelection && (
      savedSelection.cityId !== cityId || 
      savedSelection.sectorId !== sectorId
    );
    
    this.selectedCity = cityId;
    this.selectedSector = sectorId;
    this.selectedZone = zoneId;
    
    this.saveSelection(cityId, sectorId, zoneId);
    this.hideModal();
    this.showLocationBar();
    
    if (isLocationChange) {
      this.clearCart(city, sector);
    } else {
      this.showSuccessNotification();
      if (window.location.pathname === '/') {
        this.updateCartAttributes();
      } else {
        this.updateCartAttributesWithoutReload();
      }
    }
  }

  clearCart(city, sector) {
    // Visual Notification
    const loadingNotification = document.createElement('div');
    loadingNotification.style.cssText = `
      position: fixed; top: 80px; right: 20px; background: linear-gradient(135deg, #ff9800 0%, #ff6f00 100%);
      color: white; padding: 20px 30px; border-radius: 12px; box-shadow: 0 8px 24px rgba(255, 152, 0, 0.3);
      z-index: 10000; font-weight: 600; animation: slideInRight 0.5s ease;
    `;
    loadingNotification.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px;">
        <span style="font-size: 24px;">📍</span>
        <div><div style="font-size: 16px;">Location Changed!</div><div style="font-size: 13px; opacity: 0.9;">Clearing cart...</div></div>
      </div>`;
    document.body.appendChild(loadingNotification);
    
    // Operations
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
    .then(() => {
      // Update attributes after clear
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'delivery_city': city.name,
            'delivery_sector': sector.name,
            'delivery_zone': this.selectedZone,
            'delivery_zone_name': this.config.zones.find(z => z.id === this.selectedZone).name,
            'delivery_fee': sector.deliveryFee,
            'warehouse': sector.warehouse
          }
        })
      });
    })
    .then(() => {
      loadingNotification.remove();
      window.location.reload();
    })
    .catch(err => {
      console.error(err);
      loadingNotification.remove();
      window.location.reload();
    });
  }

  updateCartAttributesWithoutReload() {
    if (!this.selectedCity || !this.selectedSector) return;
    const city = this.config.cities.find(c => c.id === this.selectedCity);
    const sector = city.sectors.find(s => s.id === this.selectedSector);
    const zone = this.config.zones.find(z => z.id === this.selectedZone);
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'delivery_city': city.name,
          'delivery_sector': sector.name,
          'delivery_zone': this.selectedZone,
          'delivery_zone_name': zone.name,
          'delivery_fee': sector.deliveryFee,
          'warehouse': sector.warehouse
        }
      })
    });
  }
  
  updateCartAttributes() {
    if (!this.selectedCity || !this.selectedSector) return;
    const city = this.config.cities.find(c => c.id === this.selectedCity);
    const sector = city.sectors.find(s => s.id === this.selectedSector);
    const zone = this.config.zones.find(z => z.id === this.selectedZone);
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'delivery_city': city.name,
          'delivery_sector': sector.name,
          'delivery_zone': this.selectedZone,
          'delivery_zone_name': zone.name,
          'delivery_fee': sector.deliveryFee,
          'warehouse': sector.warehouse
        }
      })
    }).then(() => window.location.reload());
  }
  
  saveSelection(cityId, sectorId, zoneId) {
    const selection = { cityId, sectorId, zoneId, timestamp: new Date().toISOString() };
    localStorage.setItem('fthLocationSelection', JSON.stringify(selection));
    const expiry = new Date();
    expiry.setDate(expiry.getDate() + 30);
    localStorage.setItem('fthLocationExpiry', expiry.toISOString());
  }
  
  getSavedSelection() {
    const saved = localStorage.getItem('fthLocationSelection');
    const expiry = localStorage.getItem('fthLocationExpiry');
    if (expiry && new Date(expiry) < new Date()) {
      localStorage.removeItem('fthLocationSelection');
      localStorage.removeItem('fthLocationExpiry');
      return null;
    }
    return saved ? JSON.parse(saved) : null;
  }
  
  isValidSelection(selection) {
    if (!selection || !selection.cityId || !selection.sectorId || !this.config) return false;
    const city = this.config.cities.find(c => c.id === selection.cityId);
    if (!city) return false;
    return city.sectors.some(s => s.id === selection.sectorId);
  }

  showLocationBar() {
    let displayText = 'Select Location';
    let isNoLocation = true;

    if (this.selectedCity && this.selectedSector && this.config) {
        const city = this.config.cities.find(c => c.id === this.selectedCity);
        const sector = city ? city.sectors.find(s => s.id === this.selectedSector) : null;
        
        if (city && sector) {
            displayText = `${city.name}, ${sector.name}`;
            isNoLocation = false;
        }
    }

    this.updateButtonState(displayText, isNoLocation);
  }

  updateButtonState(text, isNoLocation) {
    const locationBtn = document.getElementById('headerLocationBtn');
    const locationDisplay = document.getElementById('locationDisplay');
    
    if (locationDisplay) locationDisplay.textContent = text;
    
    if (locationBtn) {
        if (isNoLocation) {
            locationBtn.classList.add('no-location');
        } else {
            locationBtn.classList.remove('no-location');
        }
        
        // Remove old listener if present (simple replacement)
        const newBtn = locationBtn.cloneNode(true);
        locationBtn.parentNode.replaceChild(newBtn, locationBtn);
        
        newBtn.onclick = (e) => {
            e.preventDefault();
            this.showModal();
        };
    }
  }
  
  showSuccessNotification() {
    const city = this.config.cities.find(c => c.id === this.selectedCity);
    const sector = city.sectors.find(s => s.id === this.selectedSector);
    
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed; top: 80px; right: 20px; background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
      color: white; padding: 20px 30px; border-radius: 12px; box-shadow: 0 8px 24px rgba(39, 174, 96, 0.3);
      z-index: 10000; font-weight: 600; animation: slideInRight 0.5s ease;
    `;
    notification.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px;">
        <span style="font-size: 24px;">✓</span>
        <div><div style="font-size: 16px;">Location Confirmed!</div><div style="font-size: 13px; opacity: 0.9;">${city.name} - ${sector.name}</div></div>
      </div>`;
    document.body.appendChild(notification);
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.5s ease';
      setTimeout(() => notification.remove(), 500);
    }, 3000);
  }
}

// Helper styles
const shakeStyle = document.createElement('style');
shakeStyle.textContent = `
  @keyframes slideInRight { from { opacity: 0; transform: translateX(400px); } to { opacity: 1; transform: translateX(0); } }
  @keyframes slideOutRight { from { opacity: 1; transform: translateX(0); } to { opacity: 0; transform: translateX(400px); } }
`;
document.head.appendChild(shakeStyle);

// Initialization
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { window.fthLocationManager = new CitySectorManager(); });
} else {
  window.fthLocationManager = new CitySectorManager();
}

// Fallbacks
window.addEventListener('load', () => {
  if (window.fthLocationManager) setTimeout(() => window.fthLocationManager.showLocationBar(), 1000);
});